const onlyNumbers = /^\d+$/;
export default onlyNumbers;
